import { ItemsWithHeader } from '../../../helpers/stringWithId';
import { HeaderIdxWithRelatedItemsIndices, NodeData } from '../typesSearchAsYouType';

export const initializeContentTree: <TItem extends { id: string; selected: boolean; value: string }>(
  sortedNodes: ItemsWithHeader<TItem>[],
) => {
  contentTree: HeaderIdxWithRelatedItemsIndices[];
  idToItemIdxMap: Map<string, number>;
  idxToHeaderMap: Map<number, NodeData>;
  idxToItemMap: Map<number, NodeData>;
} = sortedNodes => {
  const idToItemIdxMap = new Map<string, number>();
  const idxToHeaderMap = new Map<number, NodeData>();
  const idxToItemMap = new Map<number, NodeData>();
  let i = 0;
  let h = 0;

  const contentTree: HeaderIdxWithRelatedItemsIndices[] = sortedNodes.map(({ header, items }) => {
    const headerContent = { hidden: false, ...header };
    h += 1;
    idxToHeaderMap.set(h, headerContent);

    return {
      headerIndex: h,
      itemIndices: items.map(item => {
        const itemContent = { hidden: false, ...item };
        const itemKey = i;

        idxToItemMap.set(i, itemContent);
        idToItemIdxMap.set(item.id, i);

        i += 1;
        return itemKey;
      }),
    };
  });

  return { contentTree, idToItemIdxMap, idxToHeaderMap, idxToItemMap };
};
